import React from "react";

import { titleCase } from "title-case";

import * as styles from "./TeamNames.module.scss";

interface TeamNamesProps {
  eventName?: string | null;
}

const TeamNames = ({ eventName }: TeamNamesProps) => {
  const teamNamesArray = eventName?.split(/ vs.? /, 2);

  if (teamNamesArray?.length === 2) {
    return (
      <div className={styles.teamNames}>
        {teamNamesArray[0]} <span className={styles.vs}>vs</span>{" "}
        {teamNamesArray[1]}
      </div>
    );
  }

  return titleCase(eventName?.toLowerCase() ?? "");
};

export { TeamNames };
